import React from "react";
import { createPortal } from "react-dom";
import "./centeredModal.css";

export default function CenteredModal({
  children,
  panelClassName = "",
  labelledBy,
  onBackdropClick,
}) {
  if (typeof document === "undefined") return null;

  const modal = (
    <div
      className="planning-centered-modal"
      role="presentation"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) {
          onBackdropClick?.();
        }
      }}
    >
      <div
        className={`planning-centered-modal__panel ${panelClassName}`.trim()}
        role="dialog"
        aria-modal="true"
        aria-labelledby={labelledBy}
      >
        {children}
      </div>
    </div>
  );

  return createPortal(modal, document.body);
}
